const AUTH_CONFIG = {
    TOKEN_URL: process.env.REACT_APP_TOKEN_URL,
    CLIENT_ID: 'service-client',
    CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
    GRANT_TYPE: 'client_credentials'
};

// Token storage key
const TOKEN_STORAGE_KEY = 'access_token';
const TOKEN_EXPIRY_STORAGE_KEY = 'token_expiry';

export const fetchAccessToken = async () => {
    try {
        const response = await fetch(AUTH_CONFIG.TOKEN_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cookie': 'KEYCLOAK_LOCALE=en'
            },
            body: new URLSearchParams({
                client_id: AUTH_CONFIG.CLIENT_ID,
                client_secret: AUTH_CONFIG.CLIENT_SECRET,
                grant_type: AUTH_CONFIG.GRANT_TYPE
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const tokenData = await response.json();

        // Store token and expiry time
        const expiryTime = Date.now() + (tokenData.expires_in * 1000);
        localStorage.setItem(TOKEN_STORAGE_KEY, tokenData.access_token);
        localStorage.setItem(TOKEN_EXPIRY_STORAGE_KEY, expiryTime.toString());

        return tokenData;
    } catch (error) {
        console.error('Error fetching access token:', error);
        throw error;
    }
};

export const getAccessToken = async () => {
    const storedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
    const storedExpiry = localStorage.getItem(TOKEN_EXPIRY_STORAGE_KEY);

    // Check if token exists and is not expired
    if (storedToken && storedExpiry) {
        const expiryTime = parseInt(storedExpiry);
        const currentTime = Date.now();

        // Add 5 minute buffer before expiry
        const bufferTime = 5 * 60 * 1000; // 5 minutes in milliseconds

        if (currentTime < (expiryTime - bufferTime)) {
            return storedToken;
        }
    }

    // Token is expired or doesn't exist, fetch a new one
    console.log('Token expired or not found, fetching new token...');
    const tokenData = await fetchAccessToken();
    return tokenData.access_token;
};

export const clearTokens = () => {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(TOKEN_EXPIRY_STORAGE_KEY);
};

/**
 * Check if user is authenticated (has valid token)
 * @returns {boolean} Authentication status
 */
export const isAuthenticated = () => {
    const storedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
    const storedExpiry = localStorage.getItem(TOKEN_EXPIRY_STORAGE_KEY);

    if (!storedToken || !storedExpiry) {
        return false;
    }

    const expiryTime = parseInt(storedExpiry);
    const currentTime = Date.now();
    const bufferTime = 5 * 60 * 1000; // 5 minutes buffer

    return currentTime < (expiryTime - bufferTime);
};
